import { Camera, Share2, Sparkles, Tag } from "lucide-react";

/** Stegen från foto till publicerad annons – används på startsidan och /sa-fungerar-det. */
export const HOW_IT_WORKS_STEPS = [
  {
    icon: Camera,
    title: "Fota",
    description: "Ta ett foto på prylen – rakt framifrån i dagsljus funkar bäst.",
    detail:
      "Du behöver inte fixa någon studiomiljö. Ta ett foto med mobilen, gärna mot en lugn bakgrund och i dagsljus. Har du fler vinklar laddar du upp flera bilder på en gång – vi tar hand om bilderna åt dig och du kan vända dem rätt innan du publicerar.",
  },
  {
    icon: Sparkles,
    title: "Färdig text",
    description: "Vi läser av bilden och skriver rubrik och beskrivning åt dig.",
    detail:
      "Vi tittar på bilden, känner igen vad det är för pryl och skriver en säljande rubrik och en vänlig beskrivning på svenska. Vi föreslår också rätt kategori. Allt är redigerbart – du kan ändra varje ord innan du publicerar, och även efteråt när annonsen ligger uppe.",
  },
  {
    icon: Tag,
    title: "Få pris",
    description: "Du får ett realistiskt prisförslag i kronor att utgå ifrån.",
    detail:
      "Priset baseras på vad liknande begagnade prylar brukar gå för. Se det som en startpunkt – du sätter alltid slutpriset själv. Ligger annonsen uppe utan att någon hör av sig får du dessutom en rekommendation i statistiken om det kan vara läge att justera priset.",
  },
  {
    icon: Share2,
    title: "Dela",
    description: "Publicera, få en egen länk och ta emot meddelanden i appen.",
    detail:
      "Annonsen får en egen adress som syns i Google och som du kan dela var du vill. Köpare kontaktar dig via meddelanden {på}, så ditt telefonnummer och din mejladress hålls privata. Annonsen ligger uppe i 60 dagar och du kan pausa, ändra eller förnya den när du vill.",
  },
];
